<template>
    <div class="page white_bg">

        <header class="pageHeader white_bg bottomBorderBBB" style="line-height: 30px;">
            <div class="borderLayout paddingH16 paddingV8">
                <div class="middleRegion">
                    <div class="westRegion" style="width: 60px">
                        <span class="icon leftAngleBracketIcon floatL" style="margin-top: 3px;" @click="back();"></span>
                    </div>
                    <div class="centerRegion alignCenter font18r primaryTextColor bold"
                         style="height: 30px; overflow: hidden">
                        {{title}}
                    </div>
                    <div class="eastRegion font14r grey20 alignRight" style="width: 60px">
                        <span v-if="view==='read'" @click="view='edit'">编辑</span>
                        <span v-else @click="view='read'">完成</span>
                    </div>
                </div>
            </div>
        </header>

        <div class="content paddingT16 paddingH16">

            <bannerModule3Vue categoryKey="LEARN_LIST_PAGE" version="4" style="margin-bottom:10px"/>

            <!--                <div class="marginB16">-->
            <!--                    <adModule :type="adTypeEnum.LEARN_LIST_PAGE.code" version="4"/>-->
            <!--                </div>-->

            <div class="tabModule">
                <div class="tabHeader clearfix paddingB16">
                    <span class="tabOption relative fl marginR24" :class="{active : optionItem.id === tabModule.activeBizType}"
                          v-for="optionItem in tabModule.optionsList" :key="optionItem.id"
                          @click="selectTabItem(optionItem)">
                        {{optionItem.title}}
                    </span>
                </div>
            </div>

            <div class="item flexLayout" v-for="(item , index) in dataList" :key="index">

                <div class="item_img marginR16">
                    <img class="cover fullSpace roundBorder4" :src="item.coverImg || 'default_image.jpg'" alt=""
                         @click="viewItem(item)"/>
                </div>

                <div class="flexItem">
                    <div class="font14r color101010 hiddenOverflow" style="line-height: 25px; height: 75px;"
                         @click="viewItem(item)">
                        {{item.title}}
                    </div>
                    <div class="clearfix marginT12 position">
                        <div class="font14r floatL orange">
                            <template v-if="item.totalChapter">{{item.totalChapter}}节/</template>
                            {{item.learnCount}}人在学
                        </div>
                        <input type="checkbox" class="orangeCircleTickCheckbox floatR" style="width: 18px; height: 18px;"
                               :value="item.id" v-if="view=='edit'" @change="changeCheckbox(item)"/>
                    </div>
                </div>

            </div>
            <div class="alignCenter colorCCC bold" v-show="status == 'ready' && dataList.length < 1">
                <img src="icon/userIcon/nocoure_icon.png" width="261" height="230" alt="无内容" />
            </div>
        </div>

        <div class="optArea fixedBottom white_bg" style="height: 82px; border-top: solid 1px #BBBBBB; border-bottom: solid 1px #BBBBBB; z-index: 6;"
             v-show="view === 'edit'">
            <div class="clearfix" style="padding: 5px 14px; line-height: 42px;">
                <span class="color101010 fl font12r">已选</span>
                <span class="color101010 fl">{{selectedList.length}}</span>
                <span class="font16r colorF4950E fr" @click="batchRemove()">批量移除</span>
            </div>
        </div>
        <bottomMenu ref="bottomMenu" activePath="/me/meComp/learnListMore"></bottomMenu>

    </div><!-- end .page -->
</template>
<script>
// part and modules
import shixunPagePart from '@/components/shixunApp/shixunPagePart';
import adModule from '@comp/ad/oneImageAdModule'
import bottomMenu from "@comp/bottomMenu";

// data
import adTypeEnum from '@/components/ad/adTypeEnum';
import browsingBizTypeEnum from '@/data/browsingBizTypeEnum';

// util
import requestManager   from '@/components/platformApi/requestManager';
import appHelper        from '@util/appHelper';
import arrayHelper      from '@util/arrayHelper';
import {toDetailByBizType} from '@comp/shixunApp/toDetail';
import consoleApi from "@comp/platformApi/consoleApi";
import externalApp from "@data/externalApp";
import bannerModule3Vue from '../../../components/ad/bannerModule3.vue';

const config = {
    title : '我的学习记录',
    apiConfig : {
        list : {
            // url : '/portal/v4/user/center/getLearnList',
            url : 'portal/v4/user/center/getLearnHistoryList',
            // totalPagePath : 'data.pages',
            dataPath : 'data.records',
            totalPath : 'data.total',
            totalPagePath : 'data.pages'
        },
        batchRemove : {
            url : 'portal/v4/user/center/deleteLearnHistory'
        }
    }
};

export default {
    name:'learnCenter',
    extends : shixunPagePart,
    components : { adModule,bannerModule3Vue, bottomMenu },

    data(){
        return{
            adTypeEnum : adTypeEnum,
            title : config.title,
            enableDataList : true,
            autoLoadDataList : true,
            // scrollToLoadNextPage:false,
            apiConfig : config.apiConfig,

            filters : {
                range : '0'
            },

            toDetailByBizType:toDetailByBizType,

            tabModule : {
                activeBizType : 0,
                optionsList : [
                //     {
                //     id : '',
                //     bizType : '',
                //     title : '全部'
                // },
                {
                    id : 0,
                    bizType : 'browsed',
                    title : '浏览过'
                },{
                    id : 1,
                    bizType : 'downloaded',
                    title : '下载过'
                },{
                    id : 2,
                    bizType : 'learned',
                    title : '学习过'
                },]
            },

            // read | edit
            view : 'read',

            // array of string
            selectedIds : [],

            // array of object
            selectedList : [],

        }
    },
    methods:{
        viewItem(item) {

            if (this.view == 'edit')    // 编辑模式下忽略
            {
                return;
            }

            switch (item.browsingBizType)
            {
                case browsingBizTypeEnum.COURSE_VOD_SEGMENT.code :
                    appHelper.goToPage('courseDetail', {
                        id : item.vodId
                    });
                    break;
                case browsingBizTypeEnum.AUDIO_SEGMENT.code :
                    appHelper.goToPage('voiceCourseDetail', {
                        id : item.id
                    });
                    break;
                case browsingBizTypeEnum.DATUM.code :
                    appHelper.goToPage('datumDetail', {
                        id : item.id
                    });
                    break;
                case browsingBizTypeEnum.ATLAS.code :
                    appHelper.goToPage('atlasDetail', {
                        id : item.id
                    });
                    break;
                case browsingBizTypeEnum.ARTICLE.code :
                    let url = externalApp.oldShixun.baseUrl + 'html/article/detail.html?id=' + item.id;
                    appHelper.redirect(url);
                    break;
            }
        },
        selectTabItem(optionItem) {

            this.tabModule.activeBizType = optionItem.id;

            if (optionItem.id !== '')
            {
                this.filters.range = optionItem.id;
            }
            else
            {
                delete this.filters.range;
            }

            this.selectedList = [];
            this.view = 'read';

            this.reloadDataList();
        },
        isSelected(dataItem) {
            return arrayHelper.existElement(dataItem, this.selectedList);
        },
        changeCheckbox(dataItem) {
            if (this.isSelected(dataItem))
            {
                this.selectedList = arrayHelper.removeElement(this.selectedList, dataItem);
            }
            else
            {
                this.selectedList.push(dataItem);
            }
        },
        batchRemove() {

            const me = this;

            appHelper.confirm({
                title : '操作确认',
                content : '您确定移除选中内容吗？',
                okText : '确认',
                cancelText : '再想想',

            }, (result) => {
                if (!result)
                {
                    return;
                }

                let list = [];
                for (let i=0; i<this.selectedList.length; i++)
                {
                    list.push({
                        "browsingBizType" : this.selectedList[i].browsingBizType,
                        "browsingBizId" : this.selectedList[i].id
                    });
                }

                requestManager.request({
                    url : config.apiConfig.batchRemove.url,
                    method : config.apiConfig.batchRemove.method || 'delete',
                    data : {
                        params : JSON.stringify(list)
                    }
                }, (error, result) => {
                    if (error)
                    {
                        appHelper.generalAjaxError(error);
                        return;
                    }

                    if (result.errorCode)
                    {
                        appHelper.showMessage('移除失败', result.msg);
                        return;
                    }

                    appHelper.showHint('移除成功');
                    me.reloadDataList();
                });
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.main{
    box-sizing: border-box;
}

.title{
    height: 44px;
    text-align: center;
    line-height: 44px;
    font-size: 20px;
    font-weight: 400;
    color: #2C2C2C;
    overflow: hidden;
}
.back{
    float: left;
    margin-top: 4px;
}
.orange {
    color: #FF4D00;
}
.colorF4950E {
    color: #F4950E;
}
.tabOption {
    margin-right: 42px;
    color: #101010;
    &.active {
        color: #F28500;
    }
    &:last-child {
        margin-right: 0;
    }
}
.item{
    margin-top: 18px;
    display: flex;
}
.item_img{
    width: 124px;
    height: 78px;
}
.item_right{
    margin-top: 16px;
    padding: 2px 8px;
    color: #fff;
    height: 17px;
    font-size: 12px;

    font-weight: 400;

    // background: #FF4D51;

    background: #FFA724;
    border-radius: 12px;
}
</style>
